/** "Sep 17, 2026" for an ISO date/datetime string; "—" for a nullish value.
 * Shared by the dashboard Control Center feeds. */
export function formatShortDate(value: string | null | undefined): string {
  if (!value) return "—";
  return new Date(value).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
